export default "__VITE_ASSET__4ea0a04f__"